import { Component, Input, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { GamificationBootstrap } from '../../../gamification/models/gamification-bootstrap.model';
import { GamificationWeekDayView, mapGamificationWeek } from '../../../gamification/models/gamification-view.mapper';

@Component({
  selector: 'app-streak-quiz-card-mock',
  templateUrl: './streak-quiz-card-mock.component.html',
  styleUrls: ['./streak-quiz-card-mock.component.scss']
})
export class StreakQuizCardMockComponent implements OnChanges {
  @Input() loading = true;
  @Input() bootstrap: GamificationBootstrap;

  readonly weekSkeletonDays = [1, 2, 3, 4, 5, 6, 7];
  readonly durationLabel = 'about 2 min';
  readonly dayPlural = { '=1': '# day', other: '# days' };
  readonly questionPlural = { '=1': '# question', other: '# questions' };
  weatherDayCopy = 'Weather days protect a missed activity day automatically.';

  streakCount = 0;
  longestStreak = 0;
  weatherDayBalance = 0;
  weekDays: GamificationWeekDayView[] = [];
  weekSummary = '0 of 7 days completed';
  questionCount = 5;
  courseName: string;
  quizActionLabel = 'Start daily quiz';
  dailyQuizAvailable = false;
  dailyQuizComplete = false;
  isStartingQuiz = false;

  constructor(private readonly router: Router) { }

  ngOnChanges(): void {
    if (!this.bootstrap) {
      return;
    }

    this.streakCount = this.bootstrap.Summary?.CurrentProtectedStreakDays || 0;
    this.longestStreak = this.bootstrap.Summary?.LongestProtectedStreakDays || 0;
    this.weatherDayBalance = this.bootstrap.Summary?.WeatherDayBalance || 0;
    const configuration = this.bootstrap.Configuration;
    this.weatherDayCopy = `Weather days protect a missed activity day automatically. You can carry up to ${configuration?.WeatherDayMaximumBalance || 2}.`;
    this.weekDays = mapGamificationWeek(this.bootstrap.CurrentWeek, new Date(), configuration?.WeekStartDay || 0);
    this.weekSummary = `${this.weekDays.filter(day => day.completed).length} of ${this.weekDays.length} days completed`;
    this.applyDailyQuizStatus();
  }

  startDailyQuiz(): void {
    if (!this.dailyQuizAvailable || this.isStartingQuiz) {
      return;
    }

    this.isStartingQuiz = true;
    this.router.navigate(['/daily-quiz']).then(
      () => this.isStartingQuiz = false,
      () => this.isStartingQuiz = false
    );
  }

  trackByDayKey(index: number, day: GamificationWeekDayView): string {
    return day.key;
  }

  private applyDailyQuizStatus(): void {
    const status = this.bootstrap?.DailyQuiz;
    if (!status?.IsSuccess || !status.IsAvailable) {
      this.dailyQuizAvailable = false;
      this.dailyQuizComplete = false;
      this.courseName = null;
      this.quizActionLabel = 'Daily quiz unavailable';
      return;
    }

    this.questionCount = status.QuestionCount || 5;
    this.courseName = status.CourseName;
    this.dailyQuizComplete = status.QuizResult?.IsComplete === true;
    this.quizActionLabel = status.QuizResult?.IsComplete
      ? 'View daily quiz result'
      : status.QuizResult
        ? 'Resume daily quiz'
        : 'Start daily quiz';
    this.dailyQuizAvailable = true;
  }
}
